import {Component,OnInit} from '@angular/core';
import {PageHeaderItem} from "@share/component/page-header/page-header";
import {Router} from "@angular/router";
import {TabUtils} from "@share/utils/tab-utils";

/**
 * Enumération des onglets
 */
export enum Onglets {
    GEOLOCALISATION = "Geolocalisation"
}

/**
 * Composant d'affichage de la page Geolocalisation
 *
 * @author Lionel Gimenez
 * @date 05/02/2026
 */
@Component({
    host: {'data-test-id': 'geolocalisation'},
    templateUrl: './geolocalisation.component.html'
})
export class GeolocalisationComponent implements OnInit {
    /** Liste statique des onglets */
    public static listeOnglets: Array<PageHeaderItem> = [
        {
            code: Onglets.GEOLOCALISATION,
            libelle: 'admin.parametres.geolocalisation.onglets.geolocalisationParams',
            url: 'Admin/Parametre/Geolocalisation/GeolocalisationParams'
        }
    ];

    /** Liste des différents onglets disponibles dans le menu paramètres */
    listeTabItems: Array<PageHeaderItem> = GeolocalisationComponent.listeOnglets;

    /** Onglet courant */
    selectedItem: PageHeaderItem;

    /** Index de l'onglet courant */
    selectedIndex: number;

    /**
     * Constructeur
     */
    constructor(
        private router: Router,
    ) {
    }

    /**
     * Hook initialisation
     */
    ngOnInit(): void {
        //Détermination de l'onglet actif en fonction de l'URL actuelle
        this.initSelectedTab();
    }

    /**
     * Changement d'onglet
     *
     * @param selectedItem Onglet sélectionné
     */
    onSelectedItemChange(selectedItem: PageHeaderItem): void {
        if (!this.selectedItem) {
            this.selectedItem = selectedItem;
        }
        if (selectedItem?.code !== this.selectedItem?.code) {
            this.selectedItem = selectedItem;
            this.router.navigateByUrl(selectedItem.url);
        }
    }

    /**
     * Initialise l'onglet sélectionné en fonction de l'URL actuelle
     */
    private initSelectedTab(): void {
        //Utilisation de l'utilitaire TabUtils pour déterminer l'index de l'onglet actif
        this.selectedIndex = TabUtils.getSelectedTabIndexFromUrl(this.router,GeolocalisationComponent.listeOnglets);
        this.selectedItem = GeolocalisationComponent.listeOnglets[this.selectedIndex];
    }
}

